
import React from 'react';

const AddressSection = ({ address, handleCopy }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
      {Object.entries(address)
        .filter(([key]) => !['shippingService', 'carrier'].includes(key))
        .map(([key, value]) => (
          <div
            key={key}
            className="bg-[#222] px-4 py-2 rounded-lg text-sm hover:bg-[#333] cursor-pointer transition-colors"
            onClick={() => handleCopy(value)}
            title="Click to copy"
          >
            <strong className="capitalize text-[#DBAE6E]">{key}:</strong>{' '}
            <span className="text-white">
              {typeof value === 'object' ? JSON.stringify(value) : value || '-'}
            </span>
          </div>
        ))}
    </div>
  );
};

export default AddressSection;